// AdminPanel.js — JCUMAS 060.013 (duplicado de Solponiente)
import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Nav,
  Navbar,
  Card,
  Button,
  Accordion,
} from "react-bootstrap";
import logo from "../Images/logo-jcumas.png";
import "bootstrap/dist/css/bootstrap.min.css";
import FormularioPublicaciones from "./FormularioPublicaciones";
import TablaSolicitudes from "./TablaSolicitudes";
import BuscadorDocumentos from "./BuscadorDocumentos";
import FormularioNotificaciones from "./FormularioNotificaciones";
import GestionExpedientes from "./GestionExpedientes";
import GestionCertificados from "./GestionCertificados";
import Usuarios from "./Usuario";
import Footer from "../Components/Footer";
import Header from "../Components/Header";

const BASE_URL = process.env.REACT_APP_API_URL;

const AdminHome = () => {
  const [activeSection, setActiveSection] = useState("home");
  const [solicitudesNuevas, setSolicitudesNuevas] = useState(0);
  const [certificadosNuevos, setCertificadosNuevos] = useState(0);

  // Cuenta cuantas solicitudes (estandar y de certificado) el admin aun no
  // ha visto, para pintar el "pilotito" rojo en Solicitudes/Certificados
  // de la barra lateral — igual que ya se hace del lado del usuario con
  // Notificaciones/Certificados en Home.js.
  const fetchPendientes = async () => {
    try {
      const response = await fetch(`${BASE_URL}/solicitudes/completas`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (response.ok) {
        const data = await response.json();
        setSolicitudesNuevas(
          data.filter((s) => s.TipoSolicitud === "estandar" && !s.Visto).length
        );
        setCertificadosNuevos(
          data.filter((s) => s.TipoSolicitud === "certificado" && !s.Visto).length
        );
      }
    } catch (error) {
      console.error("Error al obtener solicitudes pendientes:", error);
    }
  };

  useEffect(() => {
    fetchPendientes();
  }, []);

  const navigate = (section) => {
    setActiveSection(section);
    if (section === "solicitudes" && solicitudesNuevas > 0) {
      fetch(`${BASE_URL}/solicitudes/marcar-vistas`, {
        method: "PUT",
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
        .then(() => setSolicitudesNuevas(0))
        .catch((e) => console.error("Error al marcar solicitudes como vistas:", e));
    }
    if (section === "certificados" && certificadosNuevos > 0) {
      fetch(`${BASE_URL}/solicitudes/certificados/marcar-vistas-admin`, {
        method: "PUT",
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
        .then(() => setCertificadosNuevos(0))
        .catch((e) => console.error("Error al marcar certificados como vistos:", e));
    }
  };

  const navLinks = [
    { key: "home",           icon: "bi-house",         label: "Inicio" },
    { key: "notificaciones", icon: "bi-bell",           label: "Notificaciones" },
    { key: "solicitudes",    icon: "bi-file-earmark",   label: "Solicitudes",  badge: solicitudesNuevas },
    { key: "certificados",   icon: "bi-patch-check",    label: "Certificados", badge: certificadosNuevos },
    { key: "publicaciones",  icon: "bi-megaphone",      label: "Publicaciones" },
    { key: "usuarios",       icon: "bi-people",         label: "Usuarios" },
    { key: "expedientes",    icon: "bi-folder2-open",   label: "Expedientes" },
    { key: "documentos",     icon: "bi-search",         label: "Documentos" },
  ];

  const renderContent = () => {
    switch (activeSection) {
      case "home":
        return (
          <Row className="p-2">
            {[
              {
                key: "notificaciones",
                icon: "bi-bell",
                title: "Notificaciones",
                text: "Cree y envíe notificaciones a los usuarios. Gestione el histórico de notificaciones enviadas.",
                btn: "Ir a Notificaciones",
              },
              {
                key: "solicitudes",
                icon: "bi-file-earmark-text",
                title: "Solicitudes",
                text: "Revise y gestione las solicitudes enviadas por los usuarios.",
                btn: "Ver Solicitudes",
              },
              {
                key: "documentos",
                icon: "bi-search",
                title: "Documentos",
                text: "Busque documentos de un usuario específico en el sistema.",
                btn: "Buscar Documentos",
              },
              {
                key: "publicaciones",
                icon: "bi-megaphone",
                title: "Publicaciones",
                text: "Cree publicaciones en el tablón de anuncios.",
                btn: "Crear Publicación",
              },
              {
                key: "usuarios",
                icon: "bi-people",
                title: "Usuarios",
                text: "Consulte y gestione los usuarios registrados en la plataforma.",
                btn: "Gestionar Usuarios",
              },
              {
                key: "expedientes",
                icon: "bi-folder2-open",
                title: "Expedientes",
                text: "Consulte y gestione los expedientes de los usuarios, cambie su estado y verifique documentos.",
                btn: "Ver Expedientes",
              },
              {
                key: "certificados",
                icon: "bi-patch-check",
                title: "Certificados",
                text: "Genere y firme los certificados solicitados por los usuarios a través de la oficina virtual.",
                btn: "Ver Certificados",
              },
            ].map((item) => (
              <Col md={6} key={item.key} className="mb-4">
                <Card className="shadow-sm h-100">
                  <Card.Body>
                    <Card.Title>
                      <i className={`bi ${item.icon} me-2 text-primary`}></i>
                      <strong>{item.title}</strong>
                    </Card.Title>
                    <Card.Text>{item.text}</Card.Text>
                    <Button variant="primary" onClick={() => navigate(item.key)}>
                      {item.btn}
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        );

      case "notificaciones":
        return (
          <Card className="shadow-sm" style={{ borderRadius: "0.75rem" }}>
            <Card.Body>
              <Card.Title className="mb-3">
                <i className="bi bi-bell me-2 text-primary"></i>
                <strong>Formulario de Notificaciones</strong>
              </Card.Title>
              <p className="text-muted">
                Seleccione un usuario y envíe una notificación personalizada o
                consulte el histórico.
              </p>
              <FormularioNotificaciones />
            </Card.Body>
          </Card>
        );

      case "solicitudes":
        return (
          <Card className="shadow-sm" style={{ borderRadius: "0.75rem" }}>
            <Card.Body>
              <Card.Title className="mb-1">
                <i className="bi bi-file-earmark-text me-2 text-primary"></i>
                <strong>Gestión de Solicitudes</strong>
              </Card.Title>
              <p className="text-muted small mb-3">
                <i className="bi bi-arrow-right-circle me-1"></i>
                Las solicitudes de certificado se gestionan desde la pestaña "Certificados".
              </p>
              <TablaSolicitudes />
            </Card.Body>
          </Card>
        );

      case "documentos":
        return (
          <Card className="shadow-sm" style={{ borderRadius: "0.75rem" }}>
            <Card.Body>
              <Card.Title className="mb-3">
                <i className="bi bi-search me-2 text-primary"></i>
                <strong>Búsqueda de Documentos</strong>
              </Card.Title>
              <p className="text-muted">Seleccione un usuario para buscar sus documentos.</p>
              <BuscadorDocumentos />
            </Card.Body>
          </Card>
        );

      case "publicaciones":
        return (
          <Card className="shadow-sm" style={{ borderRadius: "0.75rem" }}>
            <Card.Body>
              <Card.Title className="mb-3">
                <i className="bi bi-megaphone me-2 text-primary"></i>
                <strong>Formulario de Publicaciones</strong>
              </Card.Title>
              <p className="text-muted">Cree un nuevo anuncio para el tablón de anuncios.</p>
              <FormularioPublicaciones />
            </Card.Body>
          </Card>
        );

      case "usuarios":
        return <Usuarios />;

      case "expedientes":
        return (
          <Card className="shadow-sm" style={{ borderRadius: "0.75rem" }}>
            <Card.Body>
              <Card.Title className="mb-3">
                <i className="bi bi-folder2-open me-2 text-primary"></i>
                <strong>Gestión de Expedientes</strong>
              </Card.Title>
              <p className="text-muted">Consulte y gestione los expedientes de los usuarios.</p>
              <GestionExpedientes />
            </Card.Body>
          </Card>
        );

      case "certificados":
        return (
          <Card className="shadow-sm" style={{ borderRadius: "0.75rem" }}>
            <Card.Body>
              <Card.Title className="mb-3">
                <i className="bi bi-patch-check me-2 text-primary"></i>
                <strong>Gestión de Certificados</strong>
              </Card.Title>
              <p className="text-muted">Genere, firme y entregue los certificados solicitados por los usuarios.</p>
              <GestionCertificados />
            </Card.Body>
          </Card>
        );

      default:
        return <h3>Bienvenido al Panel de Administración</h3>;
    }
  };

  const SidebarLinks = () => (
    <Nav className="flex-column w-100">
      {navLinks.map((link) => (
        <Nav.Link
          key={link.key}
          className={`d-flex justify-content-between align-items-center ${
            activeSection === link.key ? "active" : ""
          }`}
          onClick={() => navigate(link.key)}
        >
          <div>
            <i className={`bi ${link.icon} me-2`}></i>
            {link.label}
          </div>
          {link.badge > 0 && (
            <span className="badge bg-danger rounded-pill">{link.badge}</span>
          )}
        </Nav.Link>
      ))}
      <Nav.Link
        className="text-danger"
        onClick={() => {
          localStorage.removeItem("token");
          window.location.href = "/login";
        }}
      >
        <i className="bi bi-box-arrow-right me-2"></i> Cerrar sesión
      </Nav.Link>
    </Nav>
  );

  return (
    <Container fluid className="d-flex flex-column min-vh-100">
      <Row className="flex-grow-1">
        {/* Sidebar desktop */}
        <Col xs={12} md={3} lg={2} className="sidebar bg-light p-0">
          <Navbar className="flex-column d-none d-md-flex p-0">
            <Navbar.Brand className="sidebar-brand">
              <img src={logo} alt="Logo JCUMAS 060.013" />
            </Navbar.Brand>
            <div className="px-3 w-100">
              <div className="small text-muted mb-3 fw-semibold text-uppercase">
                Panel de Administración
              </div>
              <SidebarLinks />
            </div>
          </Navbar>

          {/* Menú móvil */}
          <Col className="text-primary mt-4 mb-2 text-center d-md-none">
            <h5>Panel de Administración</h5>
          </Col>
          <Accordion className="d-block d-md-none mb-3 mx-3">
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <strong className="text-primary">Menú</strong>
              </Accordion.Header>
              <Accordion.Body className="p-0">
                <SidebarLinks />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Col>

        {/* Contenido principal */}
        <Col xs={12} md={9} lg={10} className="p-0">
          <Header subtitle="Panel de Administración" />
          <div className="p-4">
            {renderContent()}
          </div>
        </Col>
      </Row>

      <Row className="g-0">
        <Footer />
      </Row>
    </Container>
  );
};

export default AdminHome;
